export default function PlayerLinux() {
  return (
    <div className="prose">
      <h2>Linux</h2>
      <p>Installation and configuration for Linux-based Q-Play players.</p>
      <ul>
        <li>Supported distributions and packages — Todo</li>
        <li>Systemd service setup — Todo</li>
        <li>Hardware acceleration (VA-API/VPU) — Todo</li>
      </ul>
    </div>
  )
}
